import { NavItem, SeoMeta } from "../types";

export const navItems: NavItem[] = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Platform", to: "/platform" },
  { label: "Demo", to: "/demo" },
  { label: "Stories", to: "/testimonials" },
  { label: "Packages", to: "/packages" },
  { label: "Contact", to: "/contact" },
];

export const seo = {
  home: {
    title: "reviewbub | Premium Book PR and Author Marketing Platform",
    description: "reviewbub helps authors build visibility through strategic book publicity, media outreach, podcast interviews, social proof, and campaign reporting.",
  },
  services: {
    title: "Book Publicity Services | reviewbub",
    description: "Explore book marketing services for authors, including social media, reviews, print media, podcast interviews, book clubs, and billboard promotion.",
  },
  platform: {
    title: "AI PR Command Center for Authors | reviewbub Platform",
    description: "See campaign planning, journalist outreach, media coverage, and author reporting in one premium PR command center.",
  },
  demo: {
    title: "PR Campaign Dashboard Demo | reviewbub",
    description: "Preview a polished author publicity dashboard with outreach status, media fit scoring, and AI-assisted pitch angles.",
  },
  reports: {
    title: "Book PR Reporting and Media Coverage Analytics | reviewbub",
    description: "Review sample author campaign reports, journalist matches, media reach, and coverage summaries from reviewbub.",
  },
  testimonials: {
    title: "Author Success Stories and Book PR Testimonials | reviewbub",
    description: "Read sample author experiences with reviewbub book marketing, media outreach, interview campaigns, and clear campaign reporting.",
  },
  packages: {
    title: "Book Marketing Packages and Pricing | reviewbub",
    description: "Compare reviewbub book marketing packages for social media, print publicity, podcasts, book clubs, and billboard campaigns.",
  },
  contact: {
    title: "Contact reviewbub | Request a Book Publicity Consultation",
    description: "Tell reviewbub about your book, launch goals, and ideal readers. Request a custom author publicity recommendation.",
  },
  notFound: {
    title: "Page Not Found | reviewbub",
    description: "The requested reviewbub page is not available.",
  },
} satisfies Record<string, SeoMeta>;
